import React, { useState } from "react";
import rightArrow from '../../images/arrow-accordion-right.svg';
import rightArrowWhite from '../../images/arrow-accordion-right-white.svg';
import marketingPlanImage from '../../images/marketing-plan-score-icon.svg';
import marketingBudgetImage from '../../images/marketing-budget-score-icon.svg';
import fileText from '../../images/file-text.svg';
import { StaticImage } from "gatsby-plugin-image";
import MarketoForm from '../marketo/marketoForm';
import '../../sass/components/flexibleModules/_components.marketingIndexComponent.scss';

// pdf generator
// import { jsPDF } from "jspdf";

let counter = -1;
let rawWeightScore = [];
const rawWeight = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
let totalWeight = [];
let yourScorePlan = 0;
let yourScoreBudget = 0;
let answer = [];

const MarketingIndexComponent = ({ data }) => {

    const isBrowser = typeof window !== "undefined";
    // const [activeElement, setActiveElement] = useState("elem-0");

    // const updateImage = (val) => {
    //     let update = "elem-" + val;
    //     setActiveElement(update);
    // }

    const [submitted, setSubmitted] = useState(false);

    function Submit(e) {
        e.preventDefault();
        console.log('submitted');
        const formEle = document.querySelector("form");
        const formDatab = new FormData(formEle);
        console.log(formDatab);

        if(window.location.search.toLowerCase().includes('inverta')){
            fetch(
                "https://script.google.com/macros/s/AKfycbybKRMm0SP-loIl7KxJ8aaCPmEgfcDUCIqdPmK5YXrENqLRBlo4BN4LkwizYOoEMhiDXA/exec",
                {
                    method: "POST",
                    body: formDatab
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log(data);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        else{
            fetch(
                "https://script.google.com/macros/s/AKfycbynz-ZzC6PnSCmMvxZJUMsegqu611zf_fwwGc5rBd0ex0EvAJVT9INVabZBUh5DH6TN4Q/exec",
                {
                    method: "POST",
                    body: formDatab
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log(data);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        getResults();
    }

    const getResults = () => {
        var potentialScorePlan = 0;
        var potentialScoreBudget = 0;
        var countPlan = 0;
        var countBudget = 0;
        let weightedScorePlan = 0;
        let weightedScoreBudget = 0;

        for (var i = 0; i < rawWeight.length; i++) {
            rawWeightScore[i] = totalWeight[i] * rawWeight[i];
            if (rawWeight[i] === 0) {
                answer[i] = "We don't do this";
            }
            else if (rawWeight[i] === 1) {
                answer[i] = "We do some but not enough";
            }
            else if (rawWeight[i] === 1.75) {
                answer[i] = "We do this well, but there is room for improvement";
            }
            else if (rawWeight[i] === 3) {
                answer[i] = "We excel at this";
            }
            else {
                answer[i] = "I don't know if we do this";
            }
        }

        // Split into categories
        let catSplit = rawWeightScore.length / 2;

        // Plan score
        for (var i = 0; i < catSplit; i++) {
            weightedScorePlan += rawWeightScore[i];
            countPlan += parseInt(totalWeight[i]);
            potentialScorePlan = parseFloat(countPlan * 3);
        }
        // alert('weighted plan is before'+potentialScorePlan);
        // budget score
        for (var i = catSplit; i < rawWeightScore.length; i++) {
            weightedScoreBudget += rawWeightScore[i];
            countBudget += parseInt(totalWeight[i]);
            potentialScoreBudget = parseFloat(countBudget * 3);
        }

        console.log("hah" + answer);
        yourScorePlan = (weightedScorePlan / potentialScorePlan) * (100 / 2);
        yourScoreBudget = (weightedScoreBudget / potentialScoreBudget) * (100 / 2);
        // alert('potential plan is'+potentialScorePlan);

        console.log("plan score is" + Math.round(yourScorePlan));
        console.log("budget score is" + Math.round(yourScoreBudget));
        setSubmitted(true);
        if (document.querySelector('.cp-marketingIndex')) {
            window.scrollTo({
                top: document.querySelector('.cp-marketingIndex').offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        }

    }

    const updateWeight = (val1, val2) => {
        rawWeight[val2] = parseFloat(val1);
    }

    const totalWeightPush = (val) => {
        totalWeight.push(val)
    }

    const counterFunction = () => {
        counter = parseInt(counter + 1);
    }

    let val = "";
    let val2 = "";
    const generatePDF = () => {
        const { jsPDF } = require("jspdf");
        if (isBrowser) {
            const doc = new jsPDF('p', 'mm', [297, 210]);
            val = `<div style="width:200px;padding:20px;" class="l--pdf"><h1>Operational Marketing Index</h1><p>Congrats! Your score is determined on a scale of 0-100, with 50 points assigned to your plan and 50 points assigned to your budget. Below you can see how your overall score stacks up against other marketers. Get a detailed report of your results, and best practices on how to improve your operational marketing.</p><h2>Your Score is ${parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget))}</h2></div>`;
            val2 = `<div style="width:200px;padding:20px;" class="l--pdf"><h3>Score My Marketing Plan</h3><p>1 ) Our marketing plan is based on a set of measurable goals that align with company objectives : <span>${answer[0]}</span></p><p>2) We create comprehensive campaigns (thematic, integrated, etc.) to execute our strategies and achieve our goals : <span>${answer[1]}</span></p><p>3) We build best and worst case scenarios into our plan to quickly react to external and internal business factors : <span>${answer[2]}</span></p><p>4) Our marketing plan is accessible to the team at all times for visibility, collaboration, and execution : <span>${answer[3]}</span></p><p>5) Marketing campaign plans are visible for team collaboration and execution progress is reviewed weekly : <span>${answer[4]}</span></p><p>6) We have a process in place to adapt our plan in response to strategy changes or market dynamics : <span>${answer[5]}</span></p><p>7) We regularly measure return on investment on both campaigns and the overall marketing plan : <span>${answer[6]}</span></p><p>8) We can accurately forecast the likelihood of goal achievement throughout the year : <span>${answer[7]}</span></p><h3 style="margin-top:70px!important;">Score My Marketing Budget</h3><p>1 ) We divide up our marketing budget into segments or by function with clear owners for accountability : <span>${answer[8]}</span></p><p>2) We allocate 60% or more of our budget to campaigns that support our goals : <span>${answer[9]}</span></p><p>3) We accurately assign and track all expenses by campaign : <span>${answer[10]}</span></p><p>4) We have a system for easily identifying and reallocating unused budget : <span>${answer[11]}</span></p><p>5) We can always see what has been spent and what marketing budget is available : <span>${answer[12]}</span></p><p>6) We can accurately report expenses by both marketing campaign and finance budget structure/GL code : <span>${answer[13]}</span></p><p>7) We can accurately and efficiently transfer funds across marketing functions as needed : <span>${answer[14]}</span></p><p>8) We accurately and quickly reconcile our marketing expenses with finance on a weekly, monthly or quarterly basis : <span>${answer[15]}</span></p></div>`;
            doc.html(val, {
                async callback(doc) {
                    // save the document as a PDF with name of pdf_name
                    doc.addPage();
                    doc.html(val2, {
                        callback: function (doc) {
                            doc.save("report_omi.pdf");
                        }, y: 300
                    });
                },
            });
        }
    }

    // const formId = 3174;
    // const ctaOverride = "Download Now";
    // const marketoScriptId = `mktoForms-${formId}`;
    // const [isLoaded, setIsLoaded] = useState(false);
    // const [isSubmitted, setIsSubmitted] = useState(false);
    // var invalidDomains = ["@test.", "@1033edge.", "@11mail.", "@123.", "@123box.", "@123india.", "@123mail."];
    // const [unlockItem, setUnlockItem] = useState(false);

    const unlock = (val) => {
        // setUnlockItem(val);
        // setTimeout(() => {
        //     generatePDF();
        // }, 5000);
        generatePDF();
    }

    // useEffect(() => {
    //     if (!document.getElementById(marketoScriptId)) {
    //         {
    //             !isLoaded &&
    //                 loadScript();
    //         }
    //     } else {
    //         setIsLoaded(true);
    //     }

    // }, []);

    // useEffect(() => {
    //     {
    //         isLoaded &&
    //             window.MktoForms2.loadForm(
    //                 '//app-sji.marketo.com',
    //                 "323-LTC-321",
    //                 formId, function (form) {
    //                     form.onSuccess((values) => {
    //                         setIsSubmitted(true);
    //                         generatePDF();
    //                         return false;
    //                     });
    //                     form.onValidate(function () {
    //                         var email = form.vals().Email;
    //                         if (email) {
    //                             if (!isEmailGood(email)) {
    //                                 form.submitable(false);
    //                                 var emailElem = form.getFormElem().find("#Email");
    //                                 form.showErrorMessage("Must be Business email.", emailElem);
    //                             } else {
    //                                 form.submitable(true);
    //                             }
    //                         }
    //                     });
    //                 }
    //             );
    //     }
    // }, [isLoaded, formId]);

    // const isEmailGood = (email) => {
    //     for (var i = 0; i < invalidDomains.length; i++) {
    //         var domain = invalidDomains[i];
    //         if (email.indexOf(domain) != -1) {
    //             return false;
    //         }
    //     }
    //     return true;
    // }

    // const loadScript = () => {
    //     var s = document.createElement('script');
    //     s.id = marketoScriptId;
    //     s.type = 'text/javascript';
    //     s.async = true;
    //     s.src = '//app-sji.marketo.com/js/forms2/js/forms2.min.js';
    //     s.onreadystatechange = function () {
    //         if (this.readyState === 'complete' || this.readyState === 'loaded') {
    //             setIsLoaded(true);
    //         }
    //     };
    //     s.onload = () => {
    //         setIsLoaded(true);
    //     }
    //     document.getElementsByTagName('head')[0].appendChild(s);
    //     let formSelect = `#mktoForm_${formId} .mktoButton`;
    //     setTimeout(() => {
    //         if (ctaOverride && document.querySelector('.mktoButton')) {
    //             document.querySelector(formSelect).innerHTML = ctaOverride;
    //         }
    //     }, 4000);
    //     // Adding Script for Marketo forms
    //     var formScript = document.createElement('script');
    //     formScript.innerHTML = function uet_report_conversion() { window.uetq = window.uetq || []; window.uetq.push('event', '', { "event_category": "Marketo Form New Site" }); }
    //     document.getElementsByTagName('head')[0].appendChild(formScript);
    // };

    return (
        <div className="cp-marketingIndex" style={{ backgroundColor: `${data.backgroundColor}` }}>
            {/* <form className="form" onSubmit={(e) => Submit(e)}>
                <input placeholder="Your Name" name="Name" type="text" />
                <input placeholder="Your Email" name="Email" type="text" />
                <input placeholder="Your Message" name="Message" type="text" />
                <input name="Name" type="submit" />
            </form> */}
            <form onSubmit={(e) => Submit(e)} className="cp-marketingIndex__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {!submitted ?
                    <>
                        {data.operationalMarketingIndexComponentHeader &&
                            <h2>{data.operationalMarketingIndexComponentHeader}</h2>
                        }
                        {data.operationalMarketingIndexComponentTeaser &&
                            <div dangerouslySetInnerHTML={{ __html: data.operationalMarketingIndexComponentTeaser }} />
                        }
                        {/* <input placeholder="Your Name" name="Name" type="text" />
                                        <input placeholder="Your Email" name="Email" type="text" />
                                        <input placeholder="Your Message" name="Message" type="text" /> */}

                        {data.operationalMarketingIndexComponentAccordion &&
                            <>
                                {data.operationalMarketingIndexComponentAccordion.map((checkAccordion, index) => (
                                    // <div className={`cp-marketingIndex__accordion ${activeElement === `elem-${index}` ? 'is-active' : 'is-active'}`} key={index}>
                                    <div className="cp-marketingIndex__accordion is-active" key={index}>
                                        {checkAccordion.header &&
                                            <button /*onClick={() => updateImage(index)}*/ className="l--flex">
                                                <div className="l--childOne l--flex">
                                                    <img src={checkAccordion.headerIcon.sourceUrl} alt={checkAccordion.headerIcon.altText} />
                                                    <span>{checkAccordion.header}</span>
                                                </div>
                                                <div className="l--childTwo">
                                                    <img src={rightArrowWhite} alt="" />
                                                </div>
                                            </button>
                                        }
                                        <div className="l--accordionHidden">
                                            {checkAccordion.objectives &&
                                                <>
                                                    {checkAccordion.objectives.map((objective, index) => (
                                                        <>
                                                            {/* <input type="hidden" name={`Name${counter}`} value={objective.text} /> */}
                                                            <div className="l--flex" key={index} data-value={objective.value}>
                                                                {totalWeightPush(objective.value)}
                                                                {counterFunction()}
                                                                <div>
                                                                    {objective.text}
                                                                </div>
                                                                <div>
                                                                    <select name={`Value${counter}`} className={`l--select-${counter}`} data-count={`${counter}`} onChange={e => updateWeight(e.target.value, e.target.getAttribute('data-count'))}>
                                                                        <option value="0">We don't do this</option>
                                                                        <option value="1">We do some but not enough</option>
                                                                        <option value="1.75">We do this well, but there is room for improvement</option>
                                                                        <option value="3">We excel at this</option>
                                                                        <option value="0">I don't know if we do this</option>
                                                                    </select>
                                                                    <img src={rightArrow} alt="" />
                                                                </div>
                                                                <input type="hidden" name={`Name${counter}`} value={objective.text} />
                                                            </div>
                                                        </>
                                                    ))}
                                                </>
                                            }
                                        </div>
                                    </div>
                                ))}
                            </>
                        }
                        <div className="cp-additionalInputs">
                            <div className="cp-additionalInputs__name">
                                <input type="text" id="fullName" name="fullName" placeholder="full name*" required/>
                            </div>
                            <div className="cp-additionalInputs__email">
                            <input type="email" id="email" name="email" placeholder="email address*" required/>
                            </div>
                            <div className="cp-additionalInputs__company">
                            <input type="text" id="company" name="company" placeholder="company name*" required/>
                            </div>
                        </div>
                        <div className="l-buttonWrapper">
                            <button className="l-getResultsIndexScore l-button" >Get Results</button>
                            {/* <input name="Name" type="submit" value="Get Results" /> */}
                        </div>
                    </>
                    :
                    <div className="cp-omiFormSubmitted">
                        <div className="cp-omiFormSubmitted__top l--flex">
                            <div className="cp-omiFormSubmitted__top-left">
                                <h2>Operational Marketing Index</h2>
                                <p>Congrats! Your score is determined on a scale of 0-100, with 50 points assigned to your plan and 50 points assigned to your budget. Below you can see how your overall score stacks up against other marketers. Get a detailed report of your results, and best practices on how to improve your operational marketing.</p>
                            </div>
                            <div className="cp-omiFormSubmitted__top-right">
                                <p>Your Score is {parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget))}</p>
                            </div>
                        </div>
                        <div className="cp-omiFormSubmitted__bottom">
                            <h3>Operational Marketing Index Score (OMI) Breakdown</h3>
                            <div className="l--flex">
                                <div>
                                    <h4>Marketing Plan Score</h4>
                                    <p className="l--flex"><img src={marketingPlanImage} alt="" /> <span>{Math.round(yourScorePlan)}</span></p>
                                    <span>(Based on 50 total points)</span>
                                </div>
                                <div>
                                    <h4>Marketing Budget Score</h4>
                                    <p className="l--flex"><img src={marketingBudgetImage} alt="" /> <span>{Math.round(yourScoreBudget)}</span></p>
                                    <span>(Based on 50 total points)</span>
                                </div>
                            </div>
                        </div>
                        <div className="l-graphCurve">
                            <h3>See How You Stack Up</h3>
                            <svg xmlns="http://www.w3.org/2000/svg" width="1134.97" height="429.05" viewBox="0 0 1134.97 429.05">
                                <defs>
                                    <linearGradient id="a" x1="1.14" y1="1.59" x2=".14" y2="1.58" gradientUnits="objectBoundingBox">
                                        <stop offset="0" stop-color="#008bcb"></stop>
                                        <stop offset=".28" stop-color="#1f68b1"></stop>
                                        <stop offset=".66" stop-color="#4c368d"></stop>
                                        <stop offset="1" stop-color="#e82987"></stop>
                                    </linearGradient>
                                </defs>
                                <path d="M152.93 676.05V565.57s66.47-5.24 154.08-31.5 152.2-88.1 181.96-123.43C519.85 374 599.45 248.18 727.01 247.01s192.63 126.14 228.8 163.63c31.17 40.44 82.63 102.65 163.75 123.44s168.34 31.49 168.34 31.49v110.48z" transform="translate(-152.93 -247)" fill="url(#a)"></path>
                            </svg>
                            <div class={`score-bar ${parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 36 ? "l-phaseOne" :
                                parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 48 ? "l-phaseTwo" :
                                    parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 64 ? "l-phasethree" :
                                        parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 76 ? "l-phaseFour" :
                                            parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 100 ? "l-phaseFive" : "l-phaseDefault"}`}>
                                <button class="score-range" id="scoreRange1">0 - 36</button>
                                <button class="score-range" id="scoreRange2">37 - 48</button>
                                <button class="score-range" id="scoreRange3">49 - 64</button>
                                <button class="score-range" id="scoreRange4">65 - 76</button>
                                <button class="score-range" id="scoreRange5">77 - 100</button>
                            </div>
                            <div class={`your-score ${parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 36 ? "l-phaseOne" :
                                parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 48 ? "l-phaseTwo" :
                                    parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 64 ? "l-phasethree" :
                                        parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 76 ? "l-phaseFour" :
                                            parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 100 ? "l-phaseFive" : "l-phaseDefault"}`}>
                                <span>{parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget))}</span>
                                <span>Your Score</span>
                            </div>
                        </div>
                        <div className="l-scoreCategorization">
                            {parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 36 ?
                                <>
                                    <h2>Foundational Marketing Operations ⭐</h2>
                                    <p>You have the basics in place but are looking to add plan and budgeting processes and discipline for growth.</p>
                                </> :
                                parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 48 ?
                                    <>
                                        <h2>Tactical Marketing Operations ⭐⭐</h2>
                                        <p>You have a set of processes that work for baseline execution but are more focused on the tactics than the strategy.</p>
                                    </> :
                                    parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 64 ?
                                        <>
                                            <h2>Disciplined Marketing Operations ⭐⭐⭐</h2>
                                            <p>You have added rigor to your strategic marketing approach and operations for clear visibility and strong execution.</p>
                                        </> :
                                        parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 76 ?
                                            <>
                                                <h2>Measurable Marketing Operations ⭐⭐⭐⭐</h2>
                                                <p>You have a detailed set of processes and have the ability to measure the success/ROI of your plan and budget.</p>
                                            </> :
                                            parseInt(Math.round(yourScorePlan) + Math.round(yourScoreBudget)) <= 100 ?
                                                <>
                                                    <h2>Operational Marketing Excellence ⭐⭐⭐⭐⭐</h2>
                                                    <p>You have full team unification and optimization for goals, strategy, campaigns, budget, and ROI measurement.</p>
                                                </> : ""
                            }
                        </div>
                        <div className="cp-detailedReport l--flex">
                            <div className="cp-detailedReport__left l--flex">
                                <img src={fileText} alt="" />
                                <div className="cp-detailedReport__left-report">
                                    <h3>Get your Detailed Report Now</h3>
                                    <p>Download a detailed report containing your scores and best practices for improvement</p>
                                </div>
                            </div>
                            <div className="cp-detailedReport__right">
                                {/* <button className="l-button" onClick={() => generatePDF()}>Get Detailed Report</button> */}
                                <button className="l-button" onClick={() => unlock(true)}>Get Detailed Report</button>
                            </div>
                        </div>
                    </div>
                }

            </form>
            {/* {!isSubmitted &&
                    <div className={`l--formpopup ${unlockItem ? "l-showForm" : "l-hideForm"}`}>
                        <div className="l--formpopup__inner">
                            <form id={`mktoForm_${formId}`}></form>
                            <button className="cp-formpopup__close" onClick={() => unlock(false)}>
                                <StaticImage src="../../images/cross-Icon.svg" alt=""></StaticImage>
                            </button>
                        </div>
                        <button className="l-formpopupClose" onClick={() => unlock(false)}></button>
                    </div>
                } */}
            {/* <div className={`l--formpopup ${unlockItem ? "l-showForm" : "l-hideForm"}`}>
                <div className="l--formpopup__inner">
                    <MarketoForm ctaOverride="Download Now" formID="3174" formSubmitMessage="Downloading Detailed Report" />
                    <button className="cp-formpopup__close" onClick={() => unlock(false)}>
                        <StaticImage src="../../images/cross-Icon.svg" alt=""></StaticImage>
                    </button>
                </div>
                <button className="l-formpopupClose" onClick={() => unlock(false)}></button>
            </div> */}

        </div>
    );
}

export default MarketingIndexComponent;